<template>
  <section class="error">
    <slot></slot>
  </section>
</template>

<script>

export default {
  name: 'error-layout'
}

</script>



// WEBPACK FOOTER //
// src/components/layouts/error-layout.vue